import React from "react";
import { storage } from "../../../dependencies/store/storage";
import { ROLES } from "../../../constants/role";
import { getDocumentLink } from "../../../dependencies/utils/helper";

const placeholderStyle = {
  display: "inline-block",
  width: 50,
  height: 50,
  background: "#f6f9fc",
  border: "1px dashed #ccc",
  borderRadius: 4,
  textAlign: "center",
  lineHeight: "50px",
  fontSize: 11,
  color: "#999",
};

const TableColumn = ({ handleDelete, handleEdit, handleUploadImage, pageNo = 0, size = 10 }) => {
  const role = storage.getUserRole();
  return [
    {
      dataField: "",
      text: "S.No",
      formatter: (cell, row, rowIndex) => pageNo * size + (rowIndex + 1),
    },
    {
      dataField: "name",
      text: "Name",
      sort: false,
      formatter: (cell) => cell,
    },
    {
      dataField: "image",
      text: "Image",
      sort: false,
      formatter: (cell) => {
        if (!cell) return <span style={placeholderStyle}>none</span>;
        return (
          <img
            src={getDocumentLink(cell)}
            alt=""
            width={50}
            height={50}
            style={{ objectFit: "cover", borderRadius: 4 }}
            onError={(e) => {
              e.currentTarget.outerHTML = `<span style="display:inline-block;width:50px;height:50px;background:#f6f9fc;border:1px dashed #ccc;border-radius:4px;text-align:center;line-height:50px;font-size:11px;color:#999;">broken</span>`;
            }}
          />
        );
      },
    },
    {
      dataField: "price",
      text: "Amount",
      formatter: (cell) => cell,
    },
    {
      dataField: "description",
      text: "Description",
      formatter: (cell) => cell,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => cell,
    },
    {
      dataField: "_id",
      text: "Action",
      formatter: (cell, row) => (
        <div className="btn btn-group">
          <button
            className="btn btn-success"
            title="Upload image to Supabase"
            onClick={() => handleUploadImage && handleUploadImage(row)}
          >
            <i className="fas fa-image" style={{ marginRight: 4 }}></i>
            Image
          </button>
          <button className="btn btn-info" onClick={() => handleEdit(row)}>
            Edit
          </button>
          <button className="btn btn-danger" onClick={() => handleDelete(cell)}>
            Delete
          </button>
        </div>
      ),
    },
  ];
};

export default TableColumn;
